import {
    CookieConsentServiceCategory,
    CookieConsentServiceProviderKey,
} from '@src/enums'

// The page-builder's `LocaleMap` (see `builder/types.ts`) only supports
// `de`/`en`. Cookie consent services need a third `it` locale, and widening
// the shared page-builder type could affect the page builder itself, so we
// keep a small locally-scoped 3-locale map here instead.
export const COOKIE_CONSENT_SERVICE_LOCALES = ['de', 'en', 'it'] as const

export type CookieConsentServiceLocale =
    (typeof COOKIE_CONSENT_SERVICE_LOCALES)[number]

export type CookieConsentServiceLocaleMap = Record<
    CookieConsentServiceLocale,
    string
>

export const emptyCookieConsentServiceLocaleMap =
    (): CookieConsentServiceLocaleMap =>
        Object.fromEntries(
            COOKIE_CONSENT_SERVICE_LOCALES.map((locale) => [locale, ''])
        ) as CookieConsentServiceLocaleMap

export class CookieConsentService {
    id: string | null = null
    platform_name: string | null = null
    provider_key: CookieConsentServiceProviderKey | null = null
    category: CookieConsentServiceCategory | null = null
    name: CookieConsentServiceLocaleMap = emptyCookieConsentServiceLocaleMap()
    description: CookieConsentServiceLocaleMap =
        emptyCookieConsentServiceLocaleMap()
    enabled = true
    position = 0

    created_at: Date | null = null
    updated_at: Date | null = null
}
